export default __webpack_public_path__ + "static/media/info-white-background.a77527dc.png";